/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import Collapsible from 'react-collapsible';
import sanitizeHtml from 'sanitize-html';
import styled from 'styled-components';

const QandAStyles = styled.section`
  .Collapsible {
    background: #F8F6F4;
    border-radius: 12pt;
    margin-bottom: 0.75rem;
    padding: 2.75rem;
    transition: all 0.2s;
    &__trigger {
      font-weight: 700;
      display: block;
      padding: 4px 0;
      cursor: pointer;
      position: relative;
      padding-right: 30px;
      &::after {
        content: '+';
        position: absolute;
        right: 0;
        top: 0;
        color: ${props => props.theme.primary};
        font-size: 1.5rem;
        font-weight: 700;
        transition: all 0.3s;
        line-height: 1;
      }
      &.is-open {
        &::after {
          transform: rotate(135deg);
          color: #e91e63;
        }
      }
    }
    &__contentInner {
      padding: 10px 30px 10px 0;
      font-size: 1rem;
      li {
         list-style-type: none;
      }
    }
  }
`;

class QandAComponent extends Component {
  showTitle() {
    if (this.props.title) {
      return <h2>{this.props.title}</h2>;
    }
    return '';
  }

  render() {
    return (
      <QandAStyles>
        <div className="container faq-container">
          {this.showTitle()}
          {this.props.data &&
            this.props.data.map(qa => (
              <Collapsible trigger={qa.question} easing="ease-in-out" key={qa.question}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(qa.answer, {
                      allowedTags: ['p', 'ul', 'li', 'a'],
                      allowedAttributes: {
                        p: [''],
                        a: ['href']
                      },
                    }),
                  }}
                />
              </Collapsible>
            ))}
        </div>
      </QandAStyles>
    );
  }
}

export default QandAComponent;
